import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { seoMeta } from './data/mock';

// Components
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Industries from './components/Industries';
import Frameworks from './components/Frameworks';
import WhyUs from './components/WhyUs';
import Contact from './components/Contact';
import Footer from './components/Footer';

// Pages
import Solutions from './pages/Solutions';
import AgentChat from './pages/AgentChat';
import Blogs from './pages/Blogs';
import BlogPost from './pages/BlogPost';

// Home Page Component
const HomePage = () => {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Industries />
      <Frameworks />
      <WhyUs />
      <Contact />
    </>
  );
};

function App() {
  // Set document title and meta description
  useEffect(() => {
    document.title = seoMeta.title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = seoMeta.description;
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = seoMeta.keywords.join(', ');
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/:agentId" element={<AgentChat />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:blogId" element={<BlogPost />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
